import React from 'react';
import { Route } from 'react-router'

import IntellegenceMomentForm from './intellegenceMomentForm'
import IntellegenceInTimeRangeForm from './intellegenceInTimeRangeForm'

const IntelligenceDateForm = () => {
  return (
    <React.Fragment>
      <Route path='/cars/:id/intimerange' component={IntellegenceInTimeRangeForm} />
      <Route path='/cars/:id/inmoment' component={IntellegenceMomentForm} />
    </React.Fragment>
  )
}

export default React.memo(IntelligenceDateForm)
